import React from 'react';
import './style.scss';

export default function ErrorPage6() {
  return (
    <div className="not-found-container">
      <h1>Oops!</h1>
      <p>Looks like something went wrong!</p>
    </div>
  );
}
